import { StatusCritical16, StatusError16, StatusInfo16, StatusOff16, StatusOffline16, StatusSuccess16, StatusWarning16, } from '@yunex/yds-icons';
import { SvgIcon, useTheme } from '@yunex/yds-react';
import React from 'react';
import { CMP_ICON_RENDERER as CMP } from '../componentNames';
/**
 * Returns component of icon based on provided string.
 *
 * @param status string representing status.
 */
export var resolveStatusIcon = function (status) {
    var statusResolver = {
        ok: StatusSuccess16,
        error: StatusError16,
        info: StatusInfo16,
        warning: StatusWarning16,
        unknown: StatusWarning16,
        critical: StatusCritical16,
        offline: StatusOffline16,
        off: StatusOff16,
    };
    return statusResolver[status] || statusResolver.unknown;
};
export var IconRenderer = function (_a) {
    var value = _a.value;
    var palette = useTheme().palette;
    var lowerCaseValue = value === null || value === void 0 ? void 0 : value.toLowerCase();
    return (React.createElement(SvgIcon, { component: resolveStatusIcon(lowerCaseValue), htmlColor: palette.symbol[lowerCaseValue], inheritViewBox: true }));
};
IconRenderer.displayName = CMP;
export default IconRenderer;
//# sourceMappingURL=IconRenderer.js.map